import React from 'react';

import {THEME} from '../../common/css/color.styles';
import {Icon} from '../Icon';
import {type ControlsImageOverlaysControls} from './ControlImageOverlaysTypes';
import type * as Controls from './controlsImage';
import {DEFAULT_TILE_LAYOUT, defaultHideImageState} from './ImageWithOverlays';

type ControlMaskProps = {
  mask: Controls.MaskControlState;
  updateMask: (newMask: Partial<Controls.MaskControlState>) => void;
  controls: ControlsImageOverlaysControls;
  updateControls(partialConfig: Partial<ControlsImageOverlaysControls>): void;
};

export const ControlsMask: React.FC<ControlMaskProps> = ({
  mask,
  updateMask,
  controls,
  updateControls,
}) => {
  const {tileLayout = DEFAULT_TILE_LAYOUT} = controls;
  const isAllSplit = tileLayout === 'ALL_SPLIT';
  const defaultHiddenState = defaultHideImageState(tileLayout);
  const toggleImageVisibility = () => {
    if (isAllSplit) {
      const hideImage = !(mask.hideImage ?? defaultHiddenState);
      updateMask({...mask, hideImage});
    } else {
      const hideImage = !(controls.hideImage ?? defaultHiddenState);
      updateControls({...controls, hideImage});
    }
  };

  const isImageHidden =
    (isAllSplit ? mask.hideImage : controls.hideImage) ?? defaultHiddenState;

  return (
    <span>
      <Icon
        style={{
          fontSize: '1.1em',
          cursor: 'pointer',
          verticalAlign: 'middle',
          color: isImageHidden
            ? 'light-dark(grey, var(--moon-450))'
            : 'light-dark(black, var(--moon-100))',
        }}
        onClick={toggleImageVisibility}
        name="panel-images"
      />
    </span>
  );
};
